"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconVacancies = function IconVacancies(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M23.813 3.986A3.49 3.49 0 0 0 20.88 5.92L20.84 6H16v2h-5v30.31l.006.24a4.5 4.5 0 0 0 1.497 3.125A5.18 5.18 0 0 0 16.01 43H37V8h-5V6h-4.831l-.038-.081a3.49 3.49 0 0 0-3.126-1.938zM32 10v2H16v-2h-3.001L13 38.31c0 .65.25 1.273.698 1.74l.14.135c.537.482 1.22.766 1.944.809L16 41h18.999V10zM24.005 5.98a1.49 1.49 0 0 1 1.463 1.208l.156.811H30v2H18V8h4.386l.156-.81a1.49 1.49 0 0 1 1.463-1.209M24 15.97v1h-8v-1zm-1 4v-1h-7v1zm8 4v1H16v-1zm0 5v-1H16v1zm0 4v1H16v-1zm0 5v-1H16v1zm-2.5-21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m.66.03h-1.33A1.83 1.83 0 0 0 26 18.81V20h5v-1.19A1.83 1.83 0 0 0 29.16 17",
    clipRule: "evenodd"
  })));
};

export { IconVacancies, IconVacancies as default };
